import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/providers/authProvider";

export const Route = createFileRoute("/")({
  component: Index,
  beforeLoad: ({context}) => {
    if (context.auth.isAuthenticated){
      throw redirect({to: "/competitions"})
    }else{
      throw redirect({to: "/signin"})
    }
  }
});

function Index() {
  const { isAuthenticated, user } = useAuth();
  return (
    <div className="p-2">
      {isAuthenticated && user && (
        <h3 className="p-6">
          Welcome back, {user.email}!
        </h3>
      )}
      <h3>Welcome Home!</h3>
    </div>
  );
}
